import React from "react";
import { FieldValues } from "react-hook-form";

import FormGenerator from "../../form/FormGenerator";
import { FormFieldType, FormFieldTypesAllowed } from "../../../types/form/form-types";

export type CustomerManagementFormValues = {
  zoneCode: string;
  divisionCode: string;
  stnCode: string;
  customerTitle: string;
};

interface Props {
  defaultValues: FieldValues;
  handleSubmit: (form_values: CustomerManagementFormValues) => void;
  loading?: boolean;
}
const CustomerManagementForm: React.FC<Props> = ({ defaultValues, handleSubmit, loading = false }) => {
  const fields: FormFieldType[] = [
    { type: FormFieldTypesAllowed.Textfield, label: "Zone Code", id: "zoneCode", required: "Field is required" },
    {
      type: FormFieldTypesAllowed.Textfield,
      label: "Division Code",
      id: "divisionCode",
      required: "Field is required",
    },
    { type: FormFieldTypesAllowed.Textfield, label: "Station Code", id: "stnCode", required: "Field is required" },
    {
      type: FormFieldTypesAllowed.Textfield,
      label: "Customer Title",
      id: "customerTitle",
      required: false,
    },
  ];
  return (
    <FormGenerator
      defaultValues={defaultValues}
      formFields={fields}
      handleFormSubmit={handleSubmit}
      className="admin-panel_generic-form flex gap-4 items-center flex-wrap p-2"
      loading={loading}
    />
  );
};

export default CustomerManagementForm;
